function isReachable() {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "/meta.json?t=" + Date.now());
        xhr.timeout = 3000;
        xhr.setRequestHeader("Cache-Control", "no-cache");

        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                try {
                    var meta = JSON.parse(this.responseText);
                    var version = meta.version;
                    resolve([true, version]);
                } catch (e) {
                    console.error("Failed to parse meta.json", e);
                    resolve([false, 0]);
                }
            } else {
                resolve([false, 0]);
            }
        };
        xhr.onerror = function () {
            resolve([false, 0]);
        };
        xhr.ontimeout = function () {
            resolve([false, 0]);
        };
        xhr.send();
    });
}

export default isReachable;
